import { render, staticRenderFns } from "./PagedListPopularPlacesNoHighlights.vue?vue&type=template&id=71584ff0&"
import script from "./PagedListPopularPlacesNoHighlights.vue?vue&type=script&lang=js&"
export * from "./PagedListPopularPlacesNoHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports